var predictiveSearchV2Input;
var predictiveSearchV2Results;

var predictiveSearchQuery;

function PredictiveSearchV2(query)
{
  //console.log("query = " + query);

  predictiveSearchQuery = query;

  if(query.length < 2)
  {
    predictiveSearchV2Results.style.display = "none";
    HideSearchClearButton();
    return;
  }

  var encodedQuery = encodeURIComponent(query);
  //var searchurl = routes.predictive_search_url + ".json?q="+encodedQuery+"&resources[type]=product,collection,article,page,query&resources[limit]=20";
  var searchurl = routes.predictive_search_url + ".json?q="+encodedQuery+"&resources[type]=product,collection,article,page&resources[limit]=20&resources[options][fields]=title,product_type,variants.title,tag,variants.title,variants.sku,body";
  //var searchurl = routes.predictive_search_url + ".json?q="+encodedQuery+"&resources[type]=product,collection,article,page&resources[limit]=20";

  fetch(searchurl, {
      method: 'GET',
      headers: {
          'Content-Type': 'application/json'
      }
  })
  .then(res => res.json())
  .then(data => {
    //console.log("data results = " + JSON.stringify(data));
    RenderSuggestions(data);
  })
  .catch(err => {
      console.error('Error fetching suggestions:', err);
  });
}

function PredictiveSearchIsDesktop() {
  return window.matchMedia("(min-width: 768px)").matches;
}

function RenderSuggestions(data)
{


  PredictiveSearchUpdateFixedTop();
  var showSuggestions = false;

  predictiveSearchV2Results.innerHTML = "";

  var htmlOutputCombined = ""
  htmlOutputCombined +='<div class="suggestionsContainer">';
    htmlOutputCombined +='<div class="contentSuggestionsContainer">';
    htmlOutputCombined += BuildCollectionSuggestions(data);
    htmlOutputCombined += BuildContentSuggestions(data);
    htmlOutputCombined +='</div>';

    htmlOutputCombined += '<div class="productSuggestionsContainer">';
      htmlOutputCombined += '<div class="productSuggestionsTitle">';
      htmlOutputCombined += '<div class="suggestionsTitleMain">PRODUCTS</div>';
      if(data.resources.results.products.length > 0)
      {
        htmlOutputCombined += '<a href="/search?type=product&q=' + encodeURIComponent(predictiveSearchQuery) + '&tab=prod">See All Product Results</a>';
      }
      htmlOutputCombined += '</div>'

      htmlOutputCombined += BuildProductSuggestions(data);
    htmlOutputCombined += "</div>";
  htmlOutputCombined += "</div>";
  //console.log("predictiveSearchV2Results.innerHMTL" + predictiveSearchV2Results.innerHMTL);

  predictiveSearchV2Results.innerHTML = htmlOutputCombined;
  predictiveSearchV2Results.style.display = "flex";


  ShowSearchClearButton();
  /*
  if(showSuggestions)
    predictiveSearchV2Results.style.display = "block";
  else
    predictiveSearchV2Results.style.display = "none";
  */
}

function ShowSearchClearButton()
{
  //console.log("ShowSearchClearButton");
  document.querySelector('predictive-search .predictive-search-clear-button').style.display = "block";
}

function HideSearchClearButton()
{
  //console.log("HideSearchClearButton");
  document.querySelector('predictive-search .predictive-search-clear-button').style.display = "none";
}

function RunSearchClearButton()
{
  //console.log("RunSearchClearButton");
  document.querySelector('predictive-search .search__input.field__input').value = "";
  document.querySelector('predictive-search .search__input.field__input').focus();
  PredictiveSearchV2('');
}


function BuildCollectionSuggestions(data)
{
  var collectionSuggestions = '<div><a href="/collections/all">All Products</a></div>';

  //console.log("resources.results.collections.length = " + data.resources.results.collections.length);
  var totalCollectionSuggCount = 0;
  for (const nextCollection of data.resources.results.collections) {
    //console.log("Next Collection Title = " + nextCollection.title);
    if(nextCollection.title.toLowerCase() != 'all products')
    {
      collectionSuggestions += '<div><a href="'+nextCollection.url+'">' + PredictiveSearchHighlightMatches(nextCollection.title) + '</a></div>';
      totalCollectionSuggCount++;
      showSuggestions = true;
    }
  }

  var collectionSuggestionsHtml = "";
  collectionSuggestionsHtml += '<div class="collectionSuggestionsContainer">';
    collectionSuggestionsHtml += '<div class="collectionSuggestionsTitle"><div class="suggestionsTitleMain">Categories</div>';

      if(totalCollectionSuggCount > 0)
      {
        collectionSuggestionsHtml += '<a href=/search?type=product&q=' + encodeURIComponent(predictiveSearchQuery) + '&tab=cat>See All Categories</a>';
      }

    collectionSuggestionsHtml += '</div>';
    collectionSuggestionsHtml += '<div class="collectionSuggestions">'
    collectionSuggestionsHtml += collectionSuggestions;

    collectionSuggestionsHtml += '</div>';
  collectionSuggestionsHtml += '</div>';



  return collectionSuggestionsHtml;
}

function BuildContentSuggestions(data)
{
  var contentSuggestions = "";

  //console.log("resources.results.articles.length = " + data.resources.results.articles.length);
  //console.log("resources.results.pages.length = " + data.resources.results.pages.length);
  for (const nextArticle of data.resources.results.articles) {
    //console.log("Next Article Title = " + nextArticle.title);
    contentSuggestions += '<div><a href="'+nextArticle.url+'">' + PredictiveSearchHighlightMatches(nextArticle.title) + '</a></div>';
    showSuggestions = true;
  }
  for (const nextPage of data.resources.results.pages) {
    //console.log("Next Page Title = " + nextPage.title);
    console.log(searchSettingsPageExclusionArray);
    console.log("Next Page Id = " + nextPage.id);
    if(searchSettingsPageExclusionArray.includes(nextPage.id))
      continue;

    contentSuggestions += '<div><a href="'+nextPage.url+'">' + PredictiveSearchHighlightMatches(nextPage.title) + '</a></div>';
    showSuggestions = true;
  }


  var articleSuggestionsHtml = "";
  articleSuggestionsHtml += '<div class="articleSuggestionsContainer">'
    articleSuggestionsHtml += '<div class="articleSuggestionsTitle"><div class="suggestionsTitleMain">Resources</div>';


      if(contentSuggestions.length > 0)
      {
        articleSuggestionsHtml += '<a href=/search?type=product&q=' + encodeURIComponent(predictiveSearchQuery) + '&tab=rec>See All Resources</a>';
      }

    articleSuggestionsHtml += '</div>' ;
    articleSuggestionsHtml += '<div class="articleSuggestions">'
    if(contentSuggestions.length > 0)
      articleSuggestionsHtml += contentSuggestions;
    else
      articleSuggestionsHtml += 'No content pages found';
    articleSuggestionsHtml += '</div>'
  articleSuggestionsHtml += '</div>'

  return articleSuggestionsHtml;
}

function BuildProductSuggestions(data)
{

  var productsSuggestions = "";

  //console.log("resources.results.products.length = " + data.resources.results.products.length);
  const productlimit = 4;
  var count = 0;
  for (const nextProduct of data.resources.results.products) {
    productsSuggestions += '<div class="productSuggestion"><a href="'+nextProduct.url+'">';
    productsSuggestions += '<div class="productSuggestionImage"><img src="' + nextProduct.image + '&width=175" alt="'+nextProduct.title+'"></div>';
    productsSuggestions += '<div class="productSuggestionTitle">' + nextProduct.title + '</div>';
    productsSuggestions += "</a></div>";
    showSuggestions = true;
    count++;
    if(count >= productlimit)
      break;
  }

  var productSuggestionsHtml = ""

  var productSuggestionsExtraClasses = "";

  if(productsSuggestions.length == 0)
  {
    productSuggestionsExtraClasses = "productSuggestionsNoProducts";
  }

  productSuggestionsHtml += '<div class="productSuggestions '+productSuggestionsExtraClasses+'">'
  if(productsSuggestions.length > 0)
    productSuggestionsHtml += productsSuggestions;
  else
    productSuggestionsHtml += '<div class="productSuggestionsNoResultsText">No product results found for "'+predictiveSearchQuery+'". Please try searching again or browse popular products.</div><div class="productSuggestionsNoResultsBtn"><a href="/collections/trending-products" class="nw-btn nw-btn-secondary nw-btn-small">Shop Best Sellers</a></div>';
  productSuggestionsHtml += '</div>';

  return productSuggestionsHtml;
}



function PredictiveSearchClickWired()
{
  const elementsToCheck = ['predictive-search', '.predictive-search--header', '.header__icon--search'];
  const targetElements = elementsToCheck.map(selector => document.querySelector(selector));




  document.addEventListener('click', (event) => {
    const clickedElement = event.target;
    const isInsideElement = targetElements.some(el => el && el.contains(clickedElement));
    if (isInsideElement) {
      //console.log('Clicked inside a target element.');
    } else {
      //console.log('Clicked outside of the target elements.');
      ClosePredictiveSearch();
    }
  });
}

function PredictiveSearchOpenCloseButtons()
{

  document.querySelectorAll('a.header__icon--search').forEach((searchLink) => {
    searchLink.setAttribute('role', 'button');

    searchLink.addEventListener('click', (event) => {
       document.querySelectorAll('header').forEach((header) => {
        header.classList.add('header--show-search');
         setTimeout(() => document.querySelector('.search__input.field__input').focus(), 100);
       });
    });
  });
  document.querySelectorAll('button.search__button__close').forEach((closeButton) => {
    closeButton.addEventListener('click', (event) => {
      event.target.closest('header').classList.remove('header--show-search');
      PredictiveSearchEnableBodyScroll();
    });
  });
}

function ClosePredictiveSearch()
{
  var existingShowSearch =  document.querySelector('.header--show-search');

  if(existingShowSearch == undefined)
    return;

  document.querySelector('.header--show-search').classList.remove('header--show-search');

  PredictiveSearchEnableBodyScroll();
}

function PredictiveSearchDisableBodyScroll()
{
  document.body.style.overflow = 'hidden';
}

function PredictiveSearchEnableBodyScroll()
{
  document.body.style.overflow = '';
}


function PredictiveSearchHighlightMatches(originalString)
{

  const regex = new RegExp(`(${predictiveSearchQuery})`, 'gi');
  var newString = originalString.replace(regex, '<strong>$1</strong>');
  //console.log("PredictiveSearchHighlightMatches = " + newString);
  return newString;
}

var predSearchStartY = 0;
var predSearchCurrentY = 0;
var predSearchVelocityY = 0;

function PredictiveSearchScroll()
{
  const searchElement = document.querySelector('.predictive-search--header');

  searchElement.addEventListener('touchstart', (e) => {
    PredictiveSearchDisableBodyScroll();
    predSearchStartY = e.touches[0].clientY;
    predSearchVelocityY = 0;

  });

  searchElement.addEventListener('touchmove', (e) => {
    PredictiveSearchDisableBodyScroll();

    var innerSearchElement = document.querySelector('.suggestionsContainer');
    var topText = innerSearchElement.style.top;

    //console.log("topText = " + topText);




    e.preventDefault();
    const touchY = e.touches[0].clientY;
    const deltaY = touchY - predSearchStartY;
    predSearchStartY = touchY;
    predSearchVelocityY = deltaY;

    //console.log('predSearchVelocityY = ' + predSearchVelocityY);

    predSearchCurrentY += predSearchVelocityY;

    var maxScroll = (window.innerHeight - innerSearchElement.clientHeight);


    maxScroll +=  -100;

    //console.log('maxScroll = ' + maxScroll);

    //console.log('predSearchCurrentY = ' + predSearchCurrentY);


    if(predSearchCurrentY < maxScroll )
      predSearchCurrentY = maxScroll ;

    if(predSearchCurrentY > 0)
      predSearchCurrentY = 0;

    innerSearchElement.style.top = predSearchCurrentY + 'px';
  });
}


function PredictiveSearchUpdateFixedTop()
{
  const rect = document.querySelector('header.header').getBoundingClientRect();
  document.querySelector('.predictive-search--header').style.top = rect.bottom + 1 + 'px';
}


function PredictiveSearchV2Initialize()
{
  predictiveSearchV2Input = document.querySelector('predictive-search .search__input.field__input');
  predictiveSearchV2Results = document.querySelector('predictive-search .predictive-search.predictive-search--header');

    predictiveSearchV2Input.addEventListener('input', debounce(function(e) {
        var query = e.target.value.trim();
        PredictiveSearchV2(query);
    }, 300));

  PredictiveSearchClickWired();
  PredictiveSearchScroll();
  PredictiveSearchOpenCloseButtons();
  PredictiveSearchUpdateFixedTop();

  // We need to do this because of the animations on the header when it's scrolling; only on desktop.
  var timeout;
  window.setInterval(function() {
    if (timeout) {
      window.cancelAnimationFrame(timeout);
    }

    // if (PredictiveSearchIsDesktop()) {
      timeout = window.requestAnimationFrame(PredictiveSearchUpdateFixedTop);
    // }
  }, 30);

  //console.log("predictive Search V2 Initialized");
}

document.addEventListener('DOMContentLoaded', function()
{
  PredictiveSearchV2Initialize();
});




